import { render } from "./Faq-templates-tab.vue?vue&type=template&id=679d9110&scoped=true"
import script from "./Faq-templates-tab.vue?vue&type=script&lang=js"
export * from "./Faq-templates-tab.vue?vue&type=script&lang=js"

import "./Faq-templates-tab.vue?vue&type=style&index=0&id=679d9110&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679d9110"]])

export default __exports__